import ScreenWrapper from '@app/hoc/ScreenWrapper';
import { ThemedText, ThemedView } from '@app/theme';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import LottieView from 'lottie-react-native';
import {
  checkCustomerEligibilityAPI
} from '@screens/CheckCustomerEligibility/services/checkCustomerEligibilityService';
import { useAppSelector } from '@store/hooks';
import { useEffect } from 'react';
import { getNextStepId } from '@screens/KYCStepper/services/service';
import { Platform } from 'react-native';


export type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'CHECK_CUSTOMER_ELIGIBILITY'>;

const CheckCustomerEligibility = ({ navigation, route }: ScreenProps) => {
  const {userDetails} = useAppSelector(state => state.auth)

  useEffect(() => {
    const intervalId = setInterval(async () => {
      await checkCustomerEligibilityAPI({
        applicationId: userDetails?.linkedApplications[0]?.applicationId
      })
      const borrowerApplicationAPIResponse = await getNextStepId({
        applicationId: userDetails?.linkedApplications[0]?.applicationId
      })
      const nextStepId = borrowerApplicationAPIResponse?.currentStepId
      if (nextStepId !== "CHECK_CUSTOMER_ELIGIBILITY") {
        clearInterval(intervalId)
        if(Platform.OS === 'web') {
          navigation.navigate(nextStepId)
        } else {
           navigation.reset({
                      index: 0,
                      routes: [{ name: 'HOME' }, { name: nextStepId }]
          })
        }
      }
    }, 5000)

    return () => {
      clearInterval(intervalId)
    }
  }, []);


  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
      <ThemedView flex={1} backgroundColor={"bg-surface-primary"} alignItems={"center"} justifyContent={"center"}>
       <LottieView source={require("../../assets/lottie/sand_timer.json")} autoPlay={true} loop={true} style={{ width: 180, height: 180}}/>
        <ThemedText variant={"b2r"} color={"text-primary"}>
          Verifying your details...
        </ThemedText>

      </ThemedView>
    </ScreenWrapper>
  );
};

export default CheckCustomerEligibility;
